import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { CheckinsAccessService } from './checkins-access.service';

/**
 * Guards the destructive routes — currently only voiding a registration. Pair it *after* authGuard,
 * which guarantees a signed-in user; this only checks the Checkins SuperAdmin role.
 *
 * A UI hint, not the enforcement: the API carries the same policy and is the thing that actually
 * decides. This exists so the page is not reachable by typing the URL.
 */
export const superAdminGuard: CanActivateFn = () => {
  const access = inject(CheckinsAccessService);
  const router = inject(Router);

  if (access.isSuperAdmin()) {
    return true;
  }

  inject(ToastrService).error("You don't have permission to do that.");
  return router.createUrlTree(['/events']);
};
